import React, {Component} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import apis from '../../helper/api'
import swal from 'sweetalert'

let denom_default = "../../swipe/assets/app/media/img/products/denom-default.jpg"
let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class ModalReserveTransfer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            flag_processing: false,
            flag_processing_info: false,
            trx_code: "", 
            transfer_info: "",
            max_amount: 0,
            balance: 0,
            input_reserve_amount: ""
        }
        this.on_submit_reserve = this.on_submit_reserve.bind(this)
    }

    componentDidMount() {
        let self = this
        util.log(this.props.data)
        this.init()
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    init() {
        if (!this.props.data.tx_code || this.props.data.tx_code.length === 0) {
            return
        }
        let body = {
            "session_id" : this.props.session,
            "trx_code" : this.props.data.tx_code
        }
        let self = this
        let url = apis.reserve_transfer_balance_info
        this.setState({flag_processing_info: true});
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK" && payload.results) {
                            self.setState({balance: payload.results.balance_owner, max_amount: payload.results.max_reverse_allowed, input_reserve_amount: payload.results.default_reverse_value});
                        } else {
                            swal("Error!", payload.error.message, "error")
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                    }
                }
                self.setState({flag_processing_info: false})
            })
    }

    on_submit_reserve() {
        if (!this.props.data.tx_code || this.props.data.tx_code.length === 0) {
            return
        }
        let body = {
            "session_id" : this.props.session,
            "trx_code" : this.props.data.tx_code,
            "info" : this.state.transfer_info,
            "reverse_value" : this.state.input_reserve_amount
        }
        let self = this
        let url = apis.reserve_transfer_balance
        if (url.length !== 0) {
            this.setState({flag_processing: true})
            request.post(url)
                .set("Content-Type", "application/json")
                .send(body)
                .end(function(err, res) {
                    if (err || !res.ok) {
                        util.log(err)
                    } else {
                        util.log(res);
                        if (res.statusCode == 200) {
                            let payload = res.body
                            util.log(payload)
                            if (payload.status == "OK") {
                                swal(payload.error.message, "Reserve transfer balance telah berhasil dilakukan", "success")
                            } else {
                                swal("Ups!", payload.error.message, "warning")
                            }
                        } else {
                            swal("Error!", res.statusCode, "warning")
                        }
                    }
                    self.setState({flag_processing: false})
                })
        } else {
            swal("Ups!", "Maaf, terjadi kesalahan pada sistem. Silakan kontak Admin untuk informasi detil kesalahan ini", "error")
        }
    }

    render() {
        let self = this
    	let data = this.props.data

    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={false}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '500px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            RESERVE TRANSFER BALANCE
	                        </h5>
	                    </div>
	                    <div className="modal-body" style={{padding: '15px 0'}}>
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">
                                        <div className="m-card-profile__pic">
                                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                                <img src={data.photo_url.length !== 0 ? data.photo_url : photo_default} style={{width:100+'px',height:100+'px'}}/>
                                            </div>
                                        </div>
                                        <div className="m-card-profile__details" style={{textAlign: 'center', marginTop:5+'px'}}>
                                            <span style={{fontWeight: '500',margin: '0 7px'}}>
                                                TXID: {data.tx_code.toUpperCase()}
                                                <br/>AMOUNT: {data.amount}
                                                <br/>DATE: {data.tx_date}
                                            </span>
                                        </div>

                                        <div style={{margin: '20px 10px 10px 10px'}}>
                                            <div style={{marginBottom: '5px'}}>
                                                <span style={{fontWeight: '500'}} className="">
                                                    Jumlah Reserve (Max. Rp. {util.rupiah_format(this.state.max_amount)})
                                                </span>
                                            </div>
                                            <div className={this.state.flag_processing_info ? "m-loader m-loader--primary m-loader--right" : ""} style={{margin: 'auto 0'}}>
                                                <input onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" 
                                                    name="input_reserve_amount"
                                                    value={this.state.input_reserve_amount}/>
                                            </div>
                                            <div style={{marginBottom:'5px',marginTop:'12px'}}>
                                                <span style={{fontWeight: '500'}} className="">
                                                    Deskripsi / Info
                                                </span>
                                            </div>
                                            <div style={{margin: 'auto 0'}}>
                                                <input onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" 
                                                    name="transfer_info"
                                                    value={this.state.transfer_info}/>
                                            </div>
                                            <button disabled={this.state.max_amount > 0 ? false : true} onClick={(e) => this.on_submit_reserve(e)} className={this.state.flag_processing ? 'btn btn-primary m-btn m-btn--custom  m-btn--bolder m-loader m-loader--secondary m-loader--right' : 'btn btn-primary m-btn m-btn--custom  m-btn--bolder'} style={{marginTop: '20px',fontSize: 'small',paddingTop:'7px',paddingBottom:'7px'}}>Submit</button>  
                                        </div>
			                        </div>
			                    </div>
				            </div>
	                    </div>
	                    <div className="modal-footer" style={{borderTop: 0, display:'none'}}></div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    balance: state.Balance,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalReserveTransfer)



// WEBPACK FOOTER //
// ./src/component/form/dialog_reserve_transfer.js